import { useEffect } from 'react';
import { api } from './client';

/**
 * Pings the BFF presence endpoint every 30 seconds while the app is in the foreground.
 * The BFF writes a 90-second TTL key in PRESENCE KV; the friends list reads that key
 * to populate the `online` flag.
 */
export function usePresenceHeartbeat(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;
    const ping = async () => {
      if (cancelled || document.hidden) return;
      try { await api.pingPresence(); } catch { /* silent */ }
    };

    // fire immediately on mount
    ping();
    // then every 30s while the tab is active
    const interval = setInterval(ping, 30_000);
    // also ping when tab regains focus
    const onVisible = () => { if (!document.hidden) ping(); };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
}
